import { makeStyles } from '@mui/styles';
import { colors } from '@mui/material';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif'
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
    minWidth: 900
  },
  tabs: {
    flexGrow: 1
  },
  tab: {
    borderRadius: '10px 10px 0px 0px',
    marginRight: '2px',
    textTransform: 'none',
    fontSize: 16,
    fontWeight: 100,
    lineHeight: '1.2em'
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  body: {
    width: '75%',
    maxWidth: 900,
    backgroundColor: 'white',
    left: '50%',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: 10,
    padding: 20
  },
  close: {
    cursor: 'pointer',
    position: 'absolute',
    right: 20,
    top: 20
  },
  cardWrapper: {
    width: '32.5%',
    float: 'left',
    marginRight: '0.8%'
  },
  cardWrapperLast: {
    width: '100%',
    float: 'left'
  },
  title: {
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontSize: '2.50em',
    fontWeight: 100,
    lineHeight: '1.2em',
    marginBottom: theme.spacing(3)
  },
  betaTitle: {
    position: 'absolute',
    top: 30,
    left: 300,
    fontWeight: 400,
    lineHeight: '1.2em',
    color: '#f8984e',
    fontSize: '1.8em'
  },
  formControl: {
    width: 600,
    backgroundColor: '#fafafa',
    marginLeft: 20
  },
  typography: {
    background: '#fafafa',
    boxShadow:
      '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)'
  },
  tabBackground: {
    background: '#f0f0f0',
    borderRadius: '0px 5px 5px 5px',
    border: '1px solid #ddd'
  },
  '@global': {
    '.MuiTabs-root': {
      background: '#fafafa'
    },
    '.MuiTab-textColorPrimary': {
      background: colors.orange[100],
      color: '#f8984e',
      borderLeft: 'solid 1px',
      borderRight: 'solid 1px',
      borderTop: 'solid 1px',
      borderColor: colors.orange[200],
      borderRightColor: colors.orange[200],
      minWidth: 'unset',
      borderRadius: '5px 5px 0px 0px',
      height: 30
    },
    '.MuiTab-textColorPrimary.Mui-selected': {
      background: '#f8984e',
      color: '#fafafa'
    }
  }
}));

export default useStyles;
